module.exports = __webpack_public_path__ + "dd15a29ca1f14674a3800acb14413222.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/flowers.png
// module id = 283
// module chunks = 0